export type CategoryKey = 'Pinned' | 'Today' | 'Yesterday' | 'Last 7 days' | 'Last month' | 'Older'

export const CATEGORIES: { [key: string]: CategoryKey } = {
  PINNED: 'Pinned',
  TODAY: 'Today',
  YESTERDAY: 'Yesterday',
  LAST_7_DAYS: 'Last 7 days',
  LAST_MONTH: 'Last month',
  OLDER: 'Older',
}

export const getCategory = (dateInput: string | number | Date): CategoryKey => {
  const convDate = new Date(dateInput)
  convDate.setHours(0, 0, 0, 0)
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const yesterday = new Date(today)
  yesterday.setDate(today.getDate() - 1)
  if (convDate.getTime() === today.getTime()) {
    return CATEGORIES.TODAY
  }
  if (convDate.getTime() === yesterday.getTime()) {
    return CATEGORIES.YESTERDAY
  }
  const dayOfWeek = today.getDay()
  const diffToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1
  const mondayThisWeek = new Date(today)
  mondayThisWeek.setDate(today.getDate() - diffToMonday)
  if (convDate >= mondayThisWeek) {
    return CATEGORIES.LAST_7_DAYS
  }
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)
  if (convDate >= firstDayOfMonth) {
    return CATEGORIES.LAST_MONTH
  }
  return CATEGORIES.OLDER
}
